import { useState, SyntheticEvent } from "react";

import styles from './SelectComponent.module.scss';

export interface SelectItemViewModel {
	key: string;
	text: string;
}

export interface SelectProps {
	items: SelectItemViewModel[];
	selectedKey: string;
	onSelectedItemChanged: (item: SelectItemViewModel) => void;
}
export const SelectComponent = (props: SelectProps) => {
	const onSelect = (e: SyntheticEvent<HTMLSelectElement>) => {
		const selectedItem = props.items.find(x => x.key === e.currentTarget.value);
		props.onSelectedItemChanged(selectedItem!);
	};

	return (
		<select className={styles.select} onChange={onSelect} value={props.selectedKey}>
			{props.items.map(x => <option key={x.key} value={x.key}>{x.text}</option>)}
		</select>
	)
}